import type { TFunction } from 'i18next';
import { countParam } from '@/pages/catalogImport/notices';
import type { BarcodeLabels } from '../../importIssues';

/**
 * "156 new barcodes: 807 labels to print" (`components.labelList`), the
 * line the issues summary's labels notice and the suggested-fixes summary
 * share. Resolves under `components` whatever namespace `t` was bound to.
 */
export const labelsSummaryText = (
    t: TFunction,
    { barcodes, units }: BarcodeLabels,
): string =>
    t('labelList.summary', {
        ns: 'components',
        barcodes: t('labelList.newBarcodes', {
            ns: 'components',
            count: barcodes,
            barcodes: countParam(barcodes),
        }),
        labels: t('labelList.labelsToPrint', {
            ns: 'components',
            count: units,
            labels: countParam(units),
        }),
    });
